module.exports = __webpack_public_path__ + "img/factorybox3.e1454b84.jpg";